import { combineReducers } from "redux";
import mfa from "pages/Settings/MultiFactorAuth/store/mfaReducer";
import passkeys from "pages/Settings/Passkeys/store/passkeysReducer";
import appPasswords from "pages/Settings/AppPasswords/store/appPasswordsReducer";
import sharing from "pages/Settings/Sharing/store/sharingReducer";

export default combineReducers({
  mfa,
  passkeys,
  appPasswords,
  sharing
});
